import {
  applyContextOptions,
  restoreContextOptions,
} from "@gameApp/helpers/canvas/contextOptions";
import {
  applyTranslate,
  restoreTranslate,
} from "@gameApp/helpers/canvas/translate";
import type { BasicDrawOptions } from "@gameApp/helpers/canvas/types";

interface Params extends BasicDrawOptions {
  text: string | number;
  x: number;
  y: number;
  maxWidth?: number;
  withStroke?: boolean;
}

export function drawTextPure(params: Params) {
  const { context, maxWidth, withStroke, text, x, y } = params;
  applyTranslate(params);
  applyContextOptions(params);
  context.save();

  if (withStroke) {
    context.strokeText(String(text), x, y, maxWidth);
  }

  context.fillText(String(text), x, y, maxWidth);
  context.restore();
  restoreContextOptions(params);
  restoreTranslate(params);
}
